import * as React from 'react';
const NewlyAssignedChatIcon = () => (
  <svg width={8} height={8} viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width={8} height={8} rx={4} fill="#0276FE" />
  </svg>
);
export default NewlyAssignedChatIcon;
